// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NewDialog_wrap__UDoT_","dialog":"NewDialog_dialog__IzjSO"};